"use client";
import { useFormik } from "formik";
import { notify, warn } from "@/utils/notification";
import { useAppDispatch, useAppSelector } from "@/hooks/hooks";
import {
  makeSignup,
  selectLoginStatus,
} from "@/components/features/auth/authSlice";
import { userSchema } from "./validation";
import Link from "next/link";
import { useRouter } from "next/navigation";
import Spinner from "@/components/Spinner";
import { countries } from "country-data";
import { useEffect, useState } from "react";
const getCountryPhoneCodes = () => {
  return countries.all
    .map((country) => ({
      name: country.name,
      code: country.countryCallingCodes[0],
    }))
    .filter((country) => country.code);
};
const SignUp = () => {
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const formik = useFormik({
    initialValues: {
      username: "",
      email: "",
      phoneCode: "",
      phone: "",
      referral_code: "",
      password: "",
    },
    validationSchema: userSchema,
    onSubmit: async (values) => {},
  });
  const handleSubmission = async () => {
    setLoading(true);
    if(formik.errors.email||formik.errors.username||formik.errors.password){
     warn("Respect validations rules")
    }else{
    const fullPhoneNumber = `${formik.values.phoneCode}${formik.values.phone}`;
    try {
      const resultAction = await makeSignup({
        username: formik.values.username,
        email: formik.values.email,
        phone: fullPhoneNumber,
        referral_code: formik.values.referral_code,
        password: formik.values.password,
      });
      formik.resetForm();
      notify(resultAction);
      setTimeout(() => {
        router.push("/auth");
      }, 3000);
    } catch (err) {
      warn(err?.message);
    }
  }
  setLoading(false);
  };
  const [phoneCodes, setPhoneCodes] = useState([]);

  useEffect(() => {
    const codes = getCountryPhoneCodes();
    setPhoneCodes(codes);
  }, []);

  return (
    <div className="flex bg-slate-300/50 md:bg-slate-300/90 backdrop-blur-none flex-col justify-center px-6 py-4 lg:px-20 rounded-2xl border-b-2 border-slate-400">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Sign up to your account
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6" onSubmit={formik.handleSubmit}>
          <div>
            <label
              htmlFor="username"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Username
            </label>
            <div className="mt-2">
              <input
                id="username"
                type="text"
                autoComplete="username"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.username}
                className="block w-full rounded-md border-0 py-3 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
              />
              {formik.touched.username && formik.errors.username && (
                <p className="text-sm text-red-800 font-normal">
                  {formik.errors.username}
                </p>
              )}
            </div>
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Email address
            </label>
            <div className="mt-2">
              <input
                id="email"
                type="email"
                autoComplete="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                className="block w-full rounded-md border-0 py-3 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
              />
              {formik.touched.email && formik.errors.email && (
                <p className="text-sm text-red-800 font-normal">
                  {formik.errors.email}
                </p>
              )}
            </div>
          </div>

          <div>
            <label
              htmlFor="phone"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Phone number
            </label>

            <div className="mt-2 flex gap-2 w-full rounded-md border-0 !p-0 !pl-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6">
              <select
                id="phoneCode"
                value={formik.values.phoneCode}
                onChange={formik.handleChange}
                className="bg-transparent outline-none w-[20%]"
              >
                {phoneCodes.map((country, index) => (
                  <option key={index} value={country.code}>
                    ({country.name} {country.code})
                  </option>
                ))}
              </select>
              <input
                id="phone"
                name="phone"
                type="number"
                autoComplete="phone"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phone}
                className="py-3 px-4 bg-transparent outline-none w-[80%]"
              />
            </div>
            {formik.touched.phone && formik.errors.phone && (
              <p className="text-sm text-red-800 font-normal">
                {formik.errors.phone}
              </p>
            )}
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Referral Code
            </label>
            <div className="mt-2">
              <input
                id="referral_code"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referral_code}
                className="block w-full rounded-md border-0 py-3 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
              />
              {formik.touched.referral_code && formik.errors.referral_code && (
                <p className="text-sm text-red-800 font-normal">
                  {formik.errors.referral_code}
                </p>
              )}
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Password
              </label>
            </div>
            <div className="mt-2">
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                className="block w-full rounded-md border-0 py-3 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
              />
              {formik.touched.password && formik.errors.password && (
                <p className="text-sm text-red-800 font-normal">
                  {formik.errors.password}
                </p>
              )}
            </div>
          </div>

          <div>
            <button
              type="button"
              className="flex w-full justify-center rounded-md bg-orange-600 px-3 py-3 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
              onClick={handleSubmission}
            >
              {loading ? <Spinner classes="!text-white text-sm" /> : "Sign up"}
            </button>
          </div>
        </form>

        <p className="mt-10 text-center text-sm text-gray-800">
          Are you member?{" "}
          <Link
            href="/auth"
            className="font-semibold leading-6 text-white md:text-orange-600 hover:text-orange-500"
          >
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
